import Axios from "axios";
export default {
    async BusquedaPorSiniestro(vm, siniestro) {
        var datosReporte = new FormData();
        datosReporte.append("siniestro", siniestro);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Busqueda/BusquedaPorSiniestro`, datosReporte);
        return response.data;
    },
    ObtenerEstados(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Busqueda/ObtenerEstado`).then(response => {
            vm.estados.opcionesEstados = response.data;
        })
    },
    async BusquedaAvanzada_Tam(vm, busqueda) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Busqueda/BusquedaAvanzada_Tam`, busqueda);
        return response.data;
    },
    async BusquedaAvanzada(vm, busqueda) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Busqueda/BusquedaAvanzada`, busqueda);
        return response.data;
    },
    async BusquedaAvanzadaExcel(vm, busqueda) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Busqueda/BusquedaAvanzadaExcel`, busqueda);
        return response.data;
    }
}
